import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import ConsignedInventoryTable from './ConsignedInventoryTable';

const style = {};
class ConsignedInventoryPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {}

    componentDidUpdate(prevProps) {}

    showNotification(color = 'success') {
        if (this.state['showNotification']) return;

        let state = [];
        state['showNotification'] = true;
        state['notificationColor'] = color;

        this.setState(state, () => {
            setTimeout(
                function() {
                    state['showNotification'] = false;
                    state['notificationColor'] = color;
                    state['notificationMessage'] = '';
                    this.setState(state);
                }.bind(this),
                4000
            );
        });
    }

    closeNotification = () => {
        let state = [];
        state['showNotification'] = false;
        state['notificationMessage'] = '';
        this.setState(state);
    };

    render() {
        const { classes } = this.props;
        return (
            <div>
                <ConsignedInventoryTable />
            </div>
        );
    }
}

ConsignedInventoryPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {};
}

export default compose(
    withStyles(style),
    connect(mapStateToProps, {})
)(withRouter(ConsignedInventoryPage));
